import logo from "./logo.svg";
import "./App.css";
// import "./index.css";

import { use, useContext, useEffect, useMemo, useRef, useState } from "react";
import Home from "./components/Home";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  matchPath,
  redirect,
  useLocation,
  Outlet,
  Link,
  NavLink,
} from "react-router-dom";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Session from "./components/Session";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Services from "./components/Services";
import { AuthContext } from "./components/auth/AuthProvider";
import DynamicPhaseHandler from "./components/videos/phaseHandler/DynamicPhaseHandler";
import DynamicQuestionHandler from "./components/videos/phaseHandler/DynamicQuestionHandler";
import Success from "./components/Success";
import CurrentTheme from "./components/currentTheme/CurrentTheme";
import DynamicAudioHandler from "./components/videos/phaseHandler/DynamicAudioHandler";
import EndedTheme from "./components/endedTheme/EndedTheme";
import LoadingSpinner from "./components/loadingSpinner/LoadingSpinner";
import Mission from "./components/Mission";
import FAQ from "./components/FAQ";
import BillingRefunds from "./components/BillingRefunds";
import CurrentService from "./components/currentService/CurrentService";
import Terms from "./components/terms/Terms";
import ProtectedRoute from "./protectedRoute/ProtectedRoute";
import ProtectedPayment from "./protectedRoute/ProtectedPayment";
import Privacy from "./components/terms/Privacy";
import CookiePolicy from "./components/terms/CookiePolicy";
import Impressum from "./components/terms/Impressum";
import Disclaimer from "./components/terms/Disclaimer";
import "./components/style/Navbar.css";

function AppLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

const routePatterns = [
  "/",
  "/home",
  "/about",
  // "/session/:id/:phaseTitle",
  "/contact",
  "/session",
  "/services",
  "/login",
  "/signup",
  "/success",
  "/session/:id",
  "/session/:id/:phaseTitle/:hashed",
  "/session/:id/:phaseTitle/:hashed/:answerLabel",
];

function App() {
  const { user, googleUser, error, loading, setPrevLocation } =
    useContext(AuthContext);

  const location = useLocation();

  const [currLocation, setCurrLocation] = useState(null);
  const prevLocationPathname = useRef(location.pathname);

  useEffect(() => {
    setPrevLocation(prevLocationPathname.current);
    prevLocationPathname.current = location.pathname;

    setCurrLocation(localStorage.getItem("postLoginRedirect"));
  }, [location]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <>
        <div
          style={{
            fontSize: "20px",
            textAlign: "center",
            margin: "50vh auto",
          }}
        >
          <img src="/server.png" alt="server" width={100} height={100} />
          <p>{error}</p> <br /> <span>We will come back soon</span>
        </div>
      </>
    );
  }

  return (
    <>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route
            path="/session/:id/:phaseTitle/ended-theme"
            element={<EndedTheme />}
          />
        </Route>

        <Route element={<ProtectedPayment />}>
          <Route path="/success" element={<Success />} />
        </Route>

        <Route
          path="/session/:id/:phaseTitle"
          element={<DynamicPhaseHandler />}
        />

        <Route
          path="/session/:id/:phaseTitle/:hashed"
          element={<DynamicQuestionHandler />}
        />

        <Route
          path="/session/:id/:phaseTitle/:hashed/:answerLabel"
          element={<DynamicAudioHandler />}
        />

        <Route path="/login" element={<Login />} />
        <Route
          path="/signup"
          element={
            googleUser || user ? (
              <Navigate to={currLocation || "/"} replace />
            ) : (
              <Signup />
            )
          }
        />

        <Route path="/session/:id" element={<CurrentTheme />} />

        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />

          {/* <Route path="/mission" element={<Mission />} /> */}

          <Route path="/contact" element={<Contact />} />
          <Route path="/session" element={<Session />} />

          <Route path="/faq" element={<FAQ />} />

          <Route path="/billing-refunds" element={<BillingRefunds />} />

          <Route path="/pricing" element={<Services />} />
          <Route path="/pricing/:id" element={<CurrentService />} />

          <Route path="*" element={<Navigate to="/" replace />} />

          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
